export function useZenchef() {
	const { locale } = useI18n();

	const destroyZenchef = () => {
		const iframes = document.querySelectorAll(
			'iframe[class^="ZC_sdk__zc-iframe_"], iframe[class*=" ZC_sdk__zc-iframe_"]',
		);

		iframes.forEach((el) => {
			el.remove();
		});

		const sdk = document.getElementById('zenchef-sdk');
		if (sdk) {
			sdk.remove();
		}

		delete window.ZC_SDK;
	};

	const mountZenchef = () => {
		if (document.getElementById('zenchef-sdk')) {
			return;
		}

		const script = document.createElement('script');
		script.id = 'zenchef-sdk';
		script.async = true;
		script.src = 'https://sdk.zenchef.com/v1/sdk.min.js';
		document.body.appendChild(script);
	};

	onMounted(() => {
		mountZenchef();

		watch(
			() => locale.value,
			async () => {
				destroyZenchef();
				await nextTick();
				mountZenchef();
			},
			{ immediate: false },
		);
	});
}
